import React from 'react';

const ResourceDetailsSkeleton: React.FC = () => {
  return (
    <div className="flex mx-auto w-full p-4 h-auto bg-[#FFFFFF] font-work-sans">
      <div className="font-raleway flex flex-col w-full relative items-start my-12">
        {/* Shimmer overlay for entire component */}
        <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none"></div>
        
        {/* Back Button Skeleton */}
        <div className="w-[100px] h-8 bg-gray-200/70 rounded-3xl animate-pulse mb-4"></div>
        
        {/* Header Section Skeleton */}
        <div className="flex flex-row w-full mt-3 relative">
          {/* Logo Skeleton */}
          <div className="p-2 border-[#E9E9E9] w-16 h-16 border-[1px] rounded-md bg-gray-200/70 animate-pulse flex items-center justify-center"></div>
          
          {/* Name and Location Skeleton */}
          <div className="flex flex-col w-full sm:w-auto ml-4">
            {/* Name Skeleton */}
            <div className="h-6 bg-gray-200/70 rounded w-48 animate-pulse mb-2"></div>
            
            {/* Rating Skeleton */}
            <div className="h-4 bg-gray-200/70 rounded w-24 animate-pulse mb-2"></div>
            
            {/* Location Skeleton */}
            <div className="flex flex-row items-center">
              <div className="w-3 h-3 bg-gray-200/70 rounded mr-1 animate-pulse"></div>
              <div className="h-4 bg-gray-200/70 rounded w-32 animate-pulse"></div>
            </div>
          </div>
          
          {/* Action Buttons Skeleton */}
          <div className="flex flex-row ml-auto my-auto">
            <div className="w-24 h-10 bg-gray-200/70 rounded-md animate-pulse mr-2"></div>
            <div className="w-10 h-10 bg-gray-200/70 rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Background Photo Skeleton */}
        <div className="flex flex-row justify-evenly w-full h-[300px] my-2 relative">
          <div className="h-[280px] w-full rounded-md m-1 bg-gradient-to-br from-gray-200 to-gray-300 animate-pulse"></div>
        </div>

        {/* Menu Sections Skeleton */}
        <div className="flex flex-col w-full m-1 space-y-2">
          {/* Description Section Skeleton */}
          <div className="bg-white rounded-lg shadow-none border-0 relative">
            <div className="flex items-center justify-between p-4 cursor-pointer rounded-md bg-[#F8F8F8]">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gray-200/70 rounded-full animate-pulse"></div>
                <div className="h-5 bg-gray-200/70 rounded w-32 animate-pulse"></div>
              </div>
            </div>
            <div className="p-6 border-[#E9E9E9] border-[1px] rounded-lg mt-2">
              <div className="space-y-2">
                <div className="h-4 bg-gray-200/70 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-200/70 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-200/70 rounded w-5/6 animate-pulse"></div>
                <div className="h-4 bg-gray-200/70 rounded w-4/5 animate-pulse"></div>
              </div>
            </div>
          </div>

          {/* Additional Menu Items Skeleton */}
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="bg-white rounded-lg shadow-none border-0 relative">
              <div className="flex items-center justify-between p-4 cursor-pointer rounded-md bg-[#F8F8F8]">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gray-200/70 rounded-full animate-pulse"></div>
                  <div className="h-5 bg-gray-200/70 rounded w-40 animate-pulse"></div>
                </div>
              </div>
            </div>
          ))}

          {/* Action Buttons Skeleton */}
          <div className="flex flex-col space-y-2 mt-4">
            <div className="h-10 bg-gray-200/70 rounded-md w-full animate-pulse"></div>
            <div className="h-10 bg-gray-200/70 rounded-md w-full animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceDetailsSkeleton;

